var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import UsersApi from "../../../infrastructure/api/pages/users-api";
import UserFormSubmit from "./UserFormSubmit";
import TopHeader from "./TopHeader";
import { Layout } from "../../components/Layout/Layout";
import { useTranslation } from "react-i18next";
import { Box, Link, Paper, Switch, Table, TableBody, TableContainer, TableHead, TableRow, Typography, useTheme, } from "@mui/material";
import { StyledTableCell, StyledTableRow, TableRowsLoader, } from "../../components/mui-table/mui-table-helper";
import { Pencil } from "@phosphor-icons/react/dist/ssr";
import { PencilSlash } from "@phosphor-icons/react";
import UserPageFilter from "./UserPageFilter";
import { AuthenticationContext } from "../../../context/AuthenticationContext";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { checkCreateEdit, checkManage, } from "../../../application/common/utils/roles-helper";
import { Modules } from "../../../application/common/enums/screen-name";
import { filterFieldSetter, useSessionFilterMemory, } from "../../hooks/useSessionFilterMemory";
const USER_STATUS_OPTIONS = ["Active", "Inactive", "All"];
const DEFAULT_FILTERS = { status: "Active" };
const revalidateFilters = (restored) => (Object.assign(Object.assign({}, restored), { status: USER_STATUS_OPTIONS.includes(restored.status)
        ? restored.status
        : DEFAULT_FILTERS.status }));
const AllAdminUsers = () => {
    const defaultUserData = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        isDeleted: false,
        locale: "",
        roles: [],
    };
    const [rowData, setRowData] = useState([]);
    const [data, setData] = useState(defaultUserData);
    const [filters, setFilters] = useSessionFilterMemory("users", DEFAULT_FILTERS, revalidateFilters);
    const filterStatus = filters.status;
    const setFilterStatus = filterFieldSetter(setFilters, "status");
    const [userId, setUserId] = useState("");
    const [refereshGrid, setRefereshGrid] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const { t: translate } = useTranslation();
    const theme = useTheme();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const { getProfile } = useContext(AuthenticationContext);
    const [currentUser, setCurrentUser] = useState();
    useEffect(() => {
        setCurrentUser(getProfile());
    }, []);
    useEffect(() => {
        filterData(filterStatus);
    }, [refereshGrid, filterStatus]);
    const filterData = (filter) => {
        setLoading(true);
        if (filter === "All") {
            getData(null);
        }
        if (filter === "Active") {
            getData(false);
        }
        if (filter === "Inactive") {
            getData(true);
        }
    };
    const handleDeleteUser = (id) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            var input = {
                Id: id,
            };
            var result = yield UsersApi.deleteUserById(input);
            if (result.data) {
                toast.info(translate("UserDeactiveMessage"));
                setRefereshGrid(!refereshGrid);
            }
        }
        catch (error) {
            console.error("Error deleting user:", error);
        }
    });
    const handleActivateUser = (id) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            var input = {
                Id: id,
            };
            var result = yield UsersApi.ActivateUserById(input);
            if (result.data) {
                toast.info(translate("UserActiveMessage"));
                setRefereshGrid(!refereshGrid);
            }
        }
        catch (error) {
            console.error("Error activating user:", error);
        }
    });
    const getData = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            var result = yield UsersApi.getAllAdminUsers(filter);
            if (result.data) {
                setLoading(false);
                setRowData(result.data);
            }
        }
        catch (error) {
            console.error("Error while fetching adminusers:", error);
        }
    });
    const handleOpenModal = () => {
        setShowPopup(true);
    };
    const handleEditUser = (id) => __awaiter(void 0, void 0, void 0, function* () {
        if (id) {
            UsersApi.getAdminUserById(id)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setData(response.data);
                    setUserId(id);
                    handleOpenModal();
                }
            })
                .finally(() => { });
        }
    });
    const handleChange = (userId, isDeleted) => {
        if (isDeleted) {
            handleActivateUser(userId);
        }
        else {
            handleDeleteUser(userId);
        }
    };
    const columns = [
        {
            id: "firstName",
            label: translate("FirstName"),
            minWidth: 100,
            align: "left",
        },
        {
            id: "lastName",
            label: translate("LastName"),
            minWidth: 150,
            align: "left",
        },
        {
            id: "email",
            label: translate("Email"),
            minWidth: 150,
            align: "left",
        },
        {
            id: "phoneNumber",
            label: translate("PhoneNumber"),
            minWidth: 150,
            align: "left",
        },
    ];
    checkManage(RolesPermissions, Modules.Users) &&
        columns.push({
            id: "isActive",
            label: translate("isActive"),
            minWidth: 130,
            align: "left",
        });
    checkCreateEdit(RolesPermissions, Modules.Users) &&
        columns.push({
            id: "action",
            label: translate("Action"),
            minWidth: 130,
            align: "center",
        });
    const showPopupOnNewUser = () => {
        setShowPopup(true);
        setUserId("");
    };
    const handlePhoneNumberClick = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };
    return (_jsx(_Fragment, { children: _jsxs(Layout, { children: [_jsx(TopHeader, { openPopup: showPopupOnNewUser, translate: translate }), _jsx(UserPageFilter, { filter: filterStatus, setState: setFilterStatus }), _jsx(UserFormSubmit, { userId: userId, data: data, title: userId ? translate("UpdateUser") : translate("AddNewUser"), buttonText: userId ? translate("UpdateUser") : translate("AddUser"), showPopup: showPopup, translate: translate, isDisabled: (data === null || data === void 0 ? void 0 : data.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) &&
                        (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === "Super Admin", onClosePopup: () => {
                        setShowPopup(false);
                        setUserId("");
                        setData(defaultUserData);
                    }, onSave: () => setRefereshGrid(!refereshGrid) }), _jsx(Box, { sx: {
                        marginTop: "1%",
                        padding: { xs: "8px", sm: "16px 32px" },
                        bgcolor: theme.palette.common.white,
                        borderRadius: "24px",
                    }, children: _jsx(Paper, { sx: { width: "100%", overflow: "hidden", boxShadow: "none" }, children: _jsx(TableContainer, { sx: { maxHeight: "calc(100vh - 300px)", overflowY: "auto" }, children: _jsxs(Table, { stickyHeader: true, "aria-label": "sticky table", children: [_jsx(TableHead, { children: _jsx(TableRow, { sx: { backgroundColor: theme.palette.common.white }, children: columns.map((column) => (_jsx(StyledTableCell, { align: column.align, style: { minWidth: column.minWidth }, children: _jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary, fontSize: { xs: "0.8rem", sm: "1rem" } }, children: translate(`${column.label}`) }) }, column.id))) }) }), _jsx(TableBody, { children: loading ? (_jsx(TableRowsLoader, { rowsNum: 10, cellNum: 7 })) : (rowData.map((user) => (_jsxs(StyledTableRow, { children: [_jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", sx: { fontSize: { xs: "0.75rem", sm: "0.875rem" } }, children: user.firstName }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", sx: { fontSize: { xs: "0.75rem", sm: "0.875rem" } }, children: user.lastName }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Link, { href: `mailto:${user.email}`, target: "_blank", rel: "noreferrer", sx: { fontSize: { xs: "0.75rem", sm: "0.875rem" } }, children: user.email }) }), _jsx(StyledTableCell, { align: "left", children: _jsx(Link, { className: "card-body-text", style: { cursor: "pointer" }, onClick: () => handlePhoneNumberClick(user.phoneNumber), target: "_blank", rel: "noreferrer", sx: { fontSize: { xs: "0.75rem", sm: "0.875rem" } }, children: user.phoneNumber }) }), checkManage(RolesPermissions, Modules.Users) && (_jsx(StyledTableCell, { align: "left", children: _jsx(Switch, { checked: !user.isDeleted, onChange: () => handleChange(user.id, user.isDeleted), disabled: user.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId), slotProps: {
                                                            input: { "aria-label": "controlled" }
                                                        } }) })), checkCreateEdit(RolesPermissions, Modules.Users) && (_jsx(StyledTableCell, { align: "center", children: user.isDeleted ? (_jsx(PencilSlash, { size: 25, color: "grey" })) : (_jsx(Pencil, { size: 25, style: { cursor: "pointer" }, onClick: () => handleEditUser(user.id) })) }))] }, user.id)))) })] }) }) }) })] }) }));
};
export default AllAdminUsers;
